import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { generateTileClick } from 'analytics';
import { getReaderAirDate } from 'lib/onDemand';
import { DisplayLayout } from 'components/Collection/Collection.const';
import OnDemandTileList from './OnDemandTileList';
import OnDemandTileThumb from './OnDemandTileThumb';

function navLink(pathname, OnDemandClip, userSearched) {
  return {
    pathname,
    state: {
      analytics: generateTileClick(OnDemandClip.title, pathname, 'show page', userSearched),
    },
  };
}

export default class OnDemandTile extends PureComponent {
  static defaultProps = {
    show: null,
    title: '',
    publishedUtc: null,
    display: null,
    id: null,
    userSearched: null,
    isLoggedIn: false,
    isPlaying: false,
  };

  static propTypes = {
    clip: PropTypes.object.isRequired,
    id: PropTypes.string,
    show: PropTypes.object,
    title: PropTypes.string,
    publishedUtc: PropTypes.string,
    display: PropTypes.string,
    userSearched: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    isPlaying: PropTypes.bool,
    onStop: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
  };

  handlePlayToggle = () => {
    const { clip, isPlaying, onStop, onPlay } = this.props;
    if (isPlaying) {
      onStop();
    } else {
      onPlay(clip);
      // @Note: set upcoming trackss
      const { id, onOndemandStart } = clip || {};
      if (onOndemandStart) onOndemandStart(id);
    }
  };

  render() {
    const { clip, userSearched } = this.props;

    const { display, id, publishedUtc, title, show } = clip || {};

    // @FIXME
    // Sometimes, when switching from live audio to track preview, `onDemandClip` becomes null
    // for a fraction of time... this is how its patched for now. We should re-check this when
    // actual previews from backend become available.
    if (!id) {
      return null;
    }

    let station;
    let tileTo = {};
    if (show) {
      station = show.station; // eslint-disable-line
      tileTo = {
        to: navLink(`/radioshows/${show.slug}`, this.props, userSearched),
      };
    }
    const onDemandTitle = title || (show && show.name);
    const screenReaderTitle = `${onDemandTitle} van ${getReaderAirDate(publishedUtc)}`;
    const additionalProps = {
      ...this.props,
      station,
      tileTo,
      onDemandTitle,
      screenReaderTitle,
      onPlayPauseToggle: this.handlePlayToggle,
    };

    if (display === DisplayLayout.LIST) {
      return <OnDemandTileList onDemandClip={clip} {...additionalProps} />;
    }
    // @d.ravnjak do we use it or can be deleted ?
    return <OnDemandTileThumb onDemandClip={clip} {...additionalProps} />;
  }
}
